import {useContext} from 'react';

import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import {
  AssignmentContext,
  statusTypes
} from 'client/AssignmentPracticeView/assignmentPracticeView.utils';
import {isTouchPrimaryDevice} from 'lib/deviceUtils';

// One gate for every annotation surface. A submitted assignment is never
// annotatable; surfaces outside AssignmentContext (status undefined) stay open.
export function useIsAnnotationModeAvailable(): boolean {
  const {status} = useContext(AssignmentContext);
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled('student_annotations');

  return (
    status !== statusTypes.submitted && isFeatureEnabled && !isLoading && !isTouchPrimaryDevice()
  );
}
